import type { FeedbackResponse } from "@indeed/signals-schema/com/indeed/signals/schema/jspremium/FeedbackResponse";

import { Box, Flex, Button, Text } from "../../../../../../mads";
import { CheckCircle } from "../../../../../../mads/icons";
import { useI18n } from "../../../../../../shared/I18n";
import { useModalContext } from "../context/ApplicantInsightsModalContextProvider";

import { colors } from "@indeed/ifl-tokens";
import { useState } from "react";

export const ApplicantInsightsFeedback = () => {
  const gt = useI18n();
  const [feedbackClicked, setFeedbackClicked] = useState(false);
  const { dismissApplicantInsightsPopover, setApplicantInsightsPopoverProps } = useModalContext();

  return (
    <Box>
      {feedbackClicked ? (
        <Flex
          sx={{
            justifyContent: "flex-end",
            width: "100%",
            flexDirection: "row",
            alignItems: "center",
            marginTop: 12,
          }}
        >
          <CheckCircle size={"sm"} color={colors.foreground.status.success["[base]"]} />
          <Text sx={{ marginLeft: 4 }}>{gt.gettext("Thank you for your feedback!")}</Text>
        </Flex>
      ) : (
        <Flex
          sx={{
            justifyContent: "flex-end",
            width: "100%",
            flexDirection: "row",
            alignItems: "center",
            marginTop: 12,
          }}
        >
          <Text
            sx={{
              marginLeft: "auto",
            }}
          >
            {gt.gettext("Are these insights helpful?")}
          </Text>
          <Button
            variant="tertiary"
            onPress={() => {
              setFeedbackClicked(true);
              setApplicantInsightsPopoverProps({
                isOpen: true,
                modalType: "FEEDBACK",
                onDismiss: dismissApplicantInsightsPopover,
                feedbackResponse: "YES" as FeedbackResponse,
              });
            }}
          >
            {gt.gettext("Yes")}
          </Button>
          <Button
            variant="tertiary"
            onPress={() => {
              setFeedbackClicked(true);
              setApplicantInsightsPopoverProps({
                isOpen: true,
                onDismiss: dismissApplicantInsightsPopover,
                modalType: "FEEDBACK",
                feedbackResponse: "NO" as FeedbackResponse,
              });
            }}
          >
            {gt.gettext("No")}
          </Button>
        </Flex>
      )}
    </Box>
  );
};
